import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[peselValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: PeselValidatorDirective, multi: true}]
})
export class PeselValidatorDirective implements Validator {
  constructor() { }
  
  validate(control: AbstractControl): ValidationErrors | null {
    var pesel = control.value;
    if (pesel == undefined || pesel.length != 11)
     return null;
    if (/^\d+$/.test(pesel)) {
        let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
        let sum = 0;
        let controlNumber = parseInt(pesel.substring(10, 11));
    
        for (let i = 0; i < weight.length; i++) {
            sum += (parseInt(pesel.substring(i, i + 1)) * weight[i]);
        }
        sum = sum % 10;
        if (((10 - sum) % 10) != controlNumber)
          return { pesel: true };

        let year = parseInt(pesel.substring(0,2));
        let month = parseInt(pesel.substring(2,4));
        let day = parseInt(pesel.substring(4,6));
        if (month > 80 && month < 93) {
          year += 1800;
        }
        else if (month > 0 && month < 13) {
          year += 1900;
        }
        else if (month > 20 && month < 33) {
          year += 2000;
        }
        else if (month > 40 && month < 53) {
          year += 2100;
        }
        else if (month > 60 && month < 73) {
          year += 2200;
        }
        month = month % 20;
        if (month == 0 || month > 12)
          return { pesel: true };

        console.log(day + " " + month + " " + year);

        if (day == 0)
          return { pesel: true };
        if (day > 30 && (month == 4 || month == 6 || month == 9 || month == 11))
          return { pesel: true };
        if (day > 31 && (month == 1 || month == 3 || month == 5 || month == 7 || month == 8 || month == 10 || month == 12))
          return { pesel: true };
        if (month == 2 && (day > 29 || (day > 28 && !this.isLeafYear(year))))
          return { pesel: true };
        return null;
    } else
      return null;
    return {pesel:true};
  }

  private isLeafYear(year: number) : boolean{
    return (year % 4 == 0) && (year % 100 != 0) || (year % 400 == 0)
  }
}
